export const RolesPermissions = {
    ViewRoles: {
        permissionsId: 'aa93794c-1d6c-49b7-f9ee-08d9689a2271',
        permissionsName: 'View Roles',
        componentsId: null,
        components: null
    },
    ViewPermissions: {
        permissionsId: 'bf8d616c-9e13-4028-f9ef-08d9689a2271',
        permissionsName: 'View Permissions',
        componentsId: null,
        components: null
    },
    SaveRoles: {
        permissionsId: '53f351d6-71af-42c4-f9f0-08d9689a2271',
        permissionsName: 'Save Roles',
        componentsId: null,
        components: null
    },
    AddRoles: {
        permissionsId: '2b6e04a8-5053-4ac6-f9f1-08d9689a2271',
        permissionsName: 'Add Roles',
        componentsId: null,
        components: null
    },
    DeleteRoles: {
        permissionsId: 'dd4eba8e-9163-4e32-f9f2-08d9689a2271',
        permissionsName: 'Delete Roles',
        componentsId: null,
        components: null
    },
    EditViewRolesRecord: {
        permissionsId: 'abef73dd-3423-4da6-f9f3-08d9689a2271',
        permissionsName: 'Edit & View Roles Record',
        componentsId: null,
        components: null
    }

};
